(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a11y-helpers"] && !Shopify.designMode) return;
  try {
    window.FK = window.FK || {};

  (function (FK) {
    const FOCUSABLE = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'summary',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    let trapHandler = null;

    FK.getFocusable = function (container) {
      if (!container) return [];
      return Array.from(container.querySelectorAll(FOCUSABLE)).filter((el) => {
        if (el.hasAttribute('hidden')) return false;
        if (el.closest('[hidden]')) return false;
        // offsetParent is null for display:none and visibility:hidden elements.
        return el.offsetParent !== null || el === document.activeElement;
      });
    };

    FK.trapFocus = function (container, elementToFocus) {
      if (!container) return;
      if (trapHandler) document.removeEventListener('keydown', trapHandler);

      trapHandler = function (event) {
        if (event.key !== 'Tab') return;
        const focusable = FK.getFocusable(container);
        if (focusable.length === 0) {
          event.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;

        if (!container.contains(active)) {
          event.preventDefault();
          first.focus();
          return;
        }
        if (event.shiftKey && active === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        }
      };

      document.addEventListener('keydown', trapHandler);

      const target = elementToFocus || FK.getFocusable(container)[0] || container;
      if (target && typeof target.focus === 'function') {
        target.focus({ preventScroll: true });
      }
    };

    FK.removeTrapFocus = function (elementToFocus) {
      if (trapHandler) document.removeEventListener('keydown', trapHandler);
      trapHandler = null;
      if (elementToFocus && typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      }
    };

    FK.announce = function (message, priority) {
      const id = priority === 'assertive' ? 'a11y-announcer-assertive' : 'a11y-announcer-polite';
      const region = document.getElementById(id);
      if (!region || !message) return;
      // Clear first so identical consecutive messages still re-announce.
      region.textContent = '';
      window.requestAnimationFrame(function () {
        region.textContent = message;
      });
    };
  })(window.FK);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gallery-media"] && !Shopify.designMode) return;
  try {
    class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('.gallery__thumb'));

      // Roving tabindex: only the active thumb is in the tab order; arrow keys
      // move between the rest.
      this.thumbs.forEach((thumb, index) => {
        thumb.tabIndex = index === 0 ? 0 : -1;
      });

      this.addEventListener('click', (event) => {
        const zoom = event.target.closest('.gallery__zoom');
        if (zoom) {
          this.openLightbox(zoom);
          return;
        }
        const thumb = event.target.closest('[data-target]');
        if (thumb) this.activate(thumb);
      });

      this.addEventListener('keydown', (event) => this.onKeydown(event));

      this.setupLightbox();
    }

    // The lightbox only cycles through image slides (video / 3D are skipped),
    // pulling each enlarged source straight from the matching zoom button's img.
    setupLightbox() {
      this.lightbox = this.querySelector('[data-lightbox]');
      if (!this.lightbox) return;
      this.zooms = Array.from(this.querySelectorAll('.gallery__zoom'));
      this.lbImg = this.lightbox.querySelector('[data-lb-img]');
      this.lbCounter = this.lightbox.querySelector('[data-lb-counter]');
      this.lbPrev = this.lightbox.querySelector('[data-lb-prev]');
      this.lbNext = this.lightbox.querySelector('[data-lb-next]');
      const close = this.lightbox.querySelector('[data-lb-close]');

      this.lbPrev.addEventListener('click', () => this.stepLightbox(-1));
      this.lbNext.addEventListener('click', () => this.stepLightbox(1));
      close.addEventListener('click', () => this.lightbox.close());

      // Click on the backdrop (the dialog itself, outside the image) closes it.
      this.lightbox.addEventListener('click', (event) => {
        if (event.target === this.lightbox) this.lightbox.close();
      });

      this.lightbox.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.stepLightbox(1); }
        else if (event.key === 'ArrowLeft') { event.preventDefault(); this.stepLightbox(-1); }
      });
    }

    openLightbox(zoom) {
      if (!this.lightbox) return;
      this.lbIndex = this.zooms.indexOf(zoom);
      this.renderLightbox();
      const single = this.zooms.length <= 1;
      this.lbPrev.hidden = single;
      this.lbNext.hidden = single;
      this.lightbox.showModal();
    }

    stepLightbox(delta) {
      const count = this.zooms.length;
      this.lbIndex = (this.lbIndex + delta + count) % count;
      this.renderLightbox();
    }

    renderLightbox() {
      const img = this.zooms[this.lbIndex].querySelector('img');
      if (!img) return;
      this.lbImg.src = img.currentSrc || img.src;
      this.lbImg.alt = img.alt || '';
      this.lbCounter.textContent = `${this.lbIndex + 1} / ${this.zooms.length}`;
    }

    activate(thumb, focusThumb) {
      const target = thumb.getAttribute('data-target');
      this.slides.forEach((slide) => {
        const show = slide.getAttribute('data-media-id') === target;
        slide.hidden = !show;
        if (!show) this.pauseMedia(slide);
      });
      this.thumbs.forEach((button) => {
        const active = button === thumb;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
      });
      thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (focusThumb) thumb.focus();
    }

    // Switch the viewport to the slide for a given media id (e.g. the image a
    // selected variant is bound to). No-op when that media isn't in the gallery.
    showMedia(mediaId) {
      const thumb = this.thumbs.find((button) => button.getAttribute('data-target') === String(mediaId));
      if (thumb) this.activate(thumb);
    }

    // Stop playback on a slide we've navigated away from so audio/3D don't keep
    // running off-screen.
    pauseMedia(slide) {
      const video = slide.querySelector('video');
      if (video && !video.paused) video.pause();
      const iframe = slide.querySelector('iframe');
      if (iframe) iframe.src = iframe.src;
      const model = slide.querySelector('model-viewer');
      if (model && typeof model.pause === 'function') model.pause();
    }

    onKeydown(event) {
      if (!event.target.closest('.gallery__thumb')) return;
      const navKeys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
      if (!navKeys.includes(event.key)) return;
      event.preventDefault();

      const current = this.thumbs.indexOf(event.target.closest('.gallery__thumb'));
      let next = current;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = current + 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = current - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this.thumbs.length - 1;

      if (next < 0) next = this.thumbs.length - 1;
      if (next >= this.thumbs.length) next = 0;
      this.activate(this.thumbs[next], true);
    }
  }

  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', MediaGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
